import { Link } from 'react-router-dom';
import { seriesList, type Episode } from '@/mocks/series';
import { statusInfo } from '@/utils/series';

const tagCls: Record<Episode['tag'], string> = {
  新: 'bg-secondary-100 text-secondary-900',
  热: 'bg-primary-100 text-primary-700',
  沸: 'bg-primary-500 text-background-50',
};

export default function Feed() {
  const feed = seriesList
    .filter((s) => s.episodes.length > 0)
    .map((s) => ({ series: s, ep: s.episodes[s.episodes.length - 1] }))
    .sort((a, b) => (a.ep.date < b.ep.date ? 1 : -1))
    .slice(0, 7);

  return (
    <section id="fresh" className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto w-full max-w-6xl">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="text-sm font-bold tracking-wide text-primary-600">最新鲜瓜速报</p>
            <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-4xl">今日剧情更新</h2>
          </div>
          <Link
            to="/chasing"
            className="hidden items-center whitespace-nowrap rounded-full border border-background-200 px-4 py-2 text-sm font-bold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 sm:inline-flex"
          >
            查看全部
            <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
          {feed.map(({ series, ep }) => {
            const st = statusInfo[series.status];
            return (
              <Link
                key={`${series.id}-${ep.ep}`}
                to={`/story/${series.id}`}
                className="group flex gap-4 overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-3 transition-all hover:-translate-y-0.5 hover:border-background-300"
              >
                <div className="relative h-24 w-28 shrink-0 overflow-hidden rounded-xl bg-background-200 md:h-28 md:w-36">
                  <img
                    src={series.cover}
                    alt={`${series.title} 更新配图`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  />
                  <span className={`absolute left-1.5 top-1.5 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-bold ${tagCls[ep.tag]}`}>
                    {ep.tag}
                  </span>
                </div>

                <div className="flex min-w-0 flex-1 flex-col py-0.5">
                  <div className="flex flex-wrap items-center gap-2 text-xs">
                    <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-background-100 px-2 py-0.5 font-medium text-foreground-600">
                      <span className={`h-1.5 w-1.5 rounded-full ${st.dot}`}></span>
                      {series.categoryName}
                    </span>
                    <span className="whitespace-nowrap font-bold text-primary-600">{ep.ep}</span>
                    <span className="ml-auto whitespace-nowrap text-foreground-400">{ep.date}</span>
                  </div>

                  <h3 className="mt-1.5 truncate text-sm font-bold text-foreground-950 group-hover:text-primary-600 md:text-base">
                    {series.title}
                  </h3>
                  <p className="mt-1 text-xs font-medium text-foreground-600 md:text-sm">{ep.title}</p>
                  <p className="mt-1 hidden truncate text-xs text-foreground-400 md:block">{ep.points[0]}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}